import { IconComponent } from '../../icons/icon.component';
import { CommonModule, NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  SimpleChanges,
} from '@angular/core';
import { RouterModule } from '@angular/router';

export enum AvatarSize {
  ExtraSmall = 1,
  Small = 2,
  Medium = 3,
  Large = 4,
  ExtraLarge = 5,
}
/**
 * Component designed to display user profile pictures, icons, or fallback images.
 * It can be used in various scenarios across an application, ensuring accessibility
 * and dynamic customization.
 */
@Component({
  selector: 'da-avatar',
  standalone: true,
  imports: [CommonModule, RouterModule, NgClass, IconComponent],
  templateUrl: './avatar.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AvatarComponent {
  @Input() public imageUrl: string;
  @Input() public routerLink: string | any[];
  @Input() public size: AvatarSize = AvatarSize.Small;
  @Input({ required: true }) public altText!: string;
  @Input() public badgeIcon: string;
  @Input() public badgeAltText: string;
  @Input() public fallbackIcon = 'user';

  public avatarSizeClassMap = {
    [AvatarSize.ExtraSmall]: 'tw-h-4 tw-w-4',
    [AvatarSize.Small]: 'tw-h-6 tw-w-6',
    [AvatarSize.Medium]: 'tw-h-8 tw-w-8',
    [AvatarSize.Large]: 'tw-h-12 tw-w-12',
    [AvatarSize.ExtraLarge]: 'tw-h-16 tw-w-16',
  };
  public useFallback = false;
  public avatarSize = AvatarSize;

  constructor() {}

  public onError(): void {
    this.useFallback = true;
  }

  ngOnInit(): void {
    this.useFallback = !this.imageUrl;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.imageUrl) {
      this.useFallback = !this.imageUrl;
    }
  }
}
